export async function submitPaymentToBC(body_data, pat) {
	const response = await fetch(
		'https://payments.bigcommerce.com/stores/le3vzvrwix/payments',
		{
			method: 'POST',
			headers: {
				Accept: 'application/vnd.bc.v1+json',
				'Content-Type': 'application/json',
				Authorization: `PAT ${pat}`,
			},
			body: JSON.stringify(body_data),
		},
	);

	// We want this response, even if it is an error.
	return response.json();
}
